import { ENVIRONMENT_NAME, MICROSOFT_LANDING_PAGE_PATH, GOOGLE_LANDING_PAGE_PATH } from '../config';

// Debug environment variables
console.log("PresetLandingPages.js - Environment variables:", {
    ENVIRONMENT_NAME,
    MICROSOFT_LANDING_PAGE_PATH,
    GOOGLE_LANDING_PAGE_PATH
});

let AllLandingPages = [];

// Add environment-specific landing pages only
if (ENVIRONMENT_NAME === 'cn') {
    AllLandingPages = [
        {
            name: "Microsoft Login",
            landingPagePath: MICROSOFT_LANDING_PAGE_PATH,
        },
        {
            name: "Google Login",
            landingPagePath: GOOGLE_LANDING_PAGE_PATH || "/landing-page/default",
        }
    ];
} else if (ENVIRONMENT_NAME === 'cnde') {
    AllLandingPages = [
        {
            name: "Microsoft Login",
            landingPagePath: MICROSOFT_LANDING_PAGE_PATH,
        },
        {
            name: "Google Login",
            landingPagePath: GOOGLE_LANDING_PAGE_PATH || "/landing-page/default",
        }
    ];
} else {
    // Default landing pages for other environments
    AllLandingPages = [
        {
            name: "Microsoft Login",
            landingPagePath: MICROSOFT_LANDING_PAGE_PATH,
        },
        {
            name: "Google Login",
            landingPagePath: GOOGLE_LANDING_PAGE_PATH || "/landing-page/default",
        }
    ];
}

export default AllLandingPages;